import React, {useMemo} from 'react';
import {classes, style} from './rich-text-view.st.css';
import {reactSetInnerHtml} from "../react-utils/react-utils";
import {generateHTML} from "@tiptap/html";
import {RichTextContent, RichTextExtensions} from "./rich-text";
import {Mark} from "@tiptap/core";

export const RichTextView = React.memo(function RichTextView (props: RichTextView.Props) {
    const {
        richText,
        extensions,
        removeMarkingStyle = false,

        className,
        ...htmlAttributes
    } = props;

    const normalizedExtensions = useMemo(() => {

        return extensions.map(extension => {

            if (removeMarkingStyle && extension instanceof Mark) {
                return extension.extend({
                    renderHTML () {
                        return ['span', {}, 0];
                    }
                })
            }

            return extension;

        })
    }, [extensions, removeMarkingStyle])

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
            {...(
                typeof richText === 'string' ?
                    {children: richText} :
                    reactSetInnerHtml(generateHTML(richText, normalizedExtensions))
            )}
        />
    );
});

export namespace RichTextView {

    export interface Props extends React.HTMLAttributes<any> {
        children?: undefined;
        richText: RichTextContent;
        extensions: RichTextExtensions;
        removeMarkingStyle?: boolean;
    }
}
